import universalErrorHandler from 'utils/universalErrorHandler'

/**
 * Basic request handler with default error handling.
 *
 * @param makeRequest:    function that returns promise
 * @param thenFnc:        function that will run on response object (e. g. 'json' to run response.json())
 * @param onNokResponse:  JSON with error codes (404, 500 etc.) as keys for appropriate error handling functions
 * @param onFinally:      on finally callback
 * @param onFail:         on fail callback
 * @param secondChance:   set true on second go to prevent infinite loop
 */
export const requestHandler = async (makeRequest, thenFnc, onNokResponse, onFinally, onFail, secondChance) => {
  try {
    const response = await makeRequest()
    if (!response.ok) {
      if (response.status === 401 && !secondChance) {
        await requestHandler.tokenRefresher()
        return requestHandler(makeRequest, thenFnc, onNokResponse, onFinally, onFail, true)
      } else {
        (onNokResponse?.[response.status]) ? (
          onNokResponse[response.status](response)
        ) : (
          defaultErrorHandler(response)
        )
        return response
      }
    }

    return (thenFnc) ? response[thenFnc]() : response
  } catch (error) {
    if (onFail) {
      onFail(error)
    } else {
      defaultErrorHandler(error)
    }
  } finally {
    if (onFinally) {
      onFinally()
    }
  }
}

const defaultErrorHandler = response => {
  response.json ? response.json().then(r => (
    universalErrorHandler(response, response.status + ' – ' + (r?.error?.message ? r?.error?.message : 'Unknown error'))
  )) : (
    universalErrorHandler(response)
  )
}

export default requestHandler
